import { BehaviorSubject } from 'rxjs';

const sharedLang = new BehaviorSubject<{lang: 'en' | 'fr' | 'de' | 'it' | 'en-US' | 'es', timeStamp: string}>({lang: 'en', timeStamp: ''});

export { sharedLang };
